import angular from 'angular';
import { STATES } from '../../../../constants/';
import { DiyMoveConfig } from './diy-move-v2.config';

export const DiyMoveStepModule = () =>
  angular.module(STATES.STEP_DIY_MOVE, []).config(DiyMoveConfig);
